import { atom } from "recoil";
import tags from '../data/tags.json';
import  sortBy  from "lodash/sortBy";

export const tagsState = atom({
    key: 'tagsState',
    default: sortBy(Object.keys(tags).map(key => ({ label: tags[key].Titolo, value: key })), 'label')
});